export default function EmailVignettePage() {
  return (
    <div className="min-h-screen bg-bg p-6">
      <div className="mx-auto max-w-xl bg-white rounded-xl border border-border p-8 shadow-sm">
        <div className="mb-6">
          <div className="flex h-10 w-10 items-center justify-center rounded-md bg-primary">
            <i className="ri-ticket-line text-white text-[16px]" />
          </div>
        </div>
        <h1 className="text-[20px] font-bold text-ink">Your e-vignette is ready</h1>
        <p className="mt-2 text-[14px] text-ink-soft leading-relaxed">
          Your digital vignette has been activated and is attached to this email as a PDF.
        </p>

        <div className="mt-6 rounded-lg bg-primary-soft border border-primary/20 p-5 text-center">
          <div className="text-[14px] font-semibold text-primary uppercase tracking-wider">Austria e-vignette</div>
          <div className="mt-2 text-[26px] font-bold text-ink">ABC-123</div>
          <div className="mt-1 text-[14px] text-ink-soft">Valid: 10 days from 2026-05-26</div>
        </div>

        <div className="mt-6 space-y-3 text-[14px] text-ink-soft leading-relaxed">
          <p>
            Your license plate <strong className="text-ink">ABC-123</strong> is now registered in the Austrian toll system (ASFINAG).
            You do not need a physical sticker.
          </p>
          <p>
            Please download and save the attached PDF to your mobile device.
            In the unlikely event of a roadside check, you may be asked to show your confirmation.
          </p>
        </div>

        <div className="mt-6 rounded-lg bg-bg border border-border p-4 text-[13px] text-muted space-y-1">
          <p><strong className="text-ink-soft">Operator:</strong> ASFINAG</p>
          <p><strong className="text-ink-soft">Coverage:</strong> All motorways (A) and expressways (S)</p>
          <p><strong className="text-ink-soft">Enforcement:</strong> Automatic number plate recognition (ANPR)</p>
        </div>

        <div className="mt-6 text-[13px] text-muted">
          <p>Need help? Contact us at <a href="mailto:support@csdmsolutions.com" className="text-primary">support@csdmsolutions.com</a></p>
          <p className="mt-1">LeadPixel Labs LLC</p>
        </div>
      </div>
    </div>
  );
}